import { DEFAULT_LOCALE } from "./constants";
import type { SupportedLocale, TranslationCatalogs, TranslationKeyMap } from "./types";

interface LookupTranslationOptions {
  catalogs: TranslationCatalogs;
  fallbackLocale: SupportedLocale;
  keyMap: TranslationKeyMap;
  locale: SupportedLocale;
  namespace: string;
  sourceText: string;
}

export function lookupTranslation(options: LookupTranslationOptions): string {
  const keyEntry = options.keyMap[options.namespace]?.[options.sourceText];

  if (keyEntry === undefined) {
    return options.sourceText;
  }

  return (
    getTranslation({
      catalogs: options.catalogs,
      hash: keyEntry.hash,
      locale: options.locale,
      namespace: options.namespace,
    }) ??
    getTranslation({
      catalogs: options.catalogs,
      hash: keyEntry.hash,
      locale: options.fallbackLocale,
      namespace: options.namespace,
    }) ??
    getTranslation({
      catalogs: options.catalogs,
      hash: keyEntry.hash,
      locale: DEFAULT_LOCALE,
      namespace: options.namespace,
    }) ??
    options.sourceText
  );
}

interface GetTranslationOptions {
  catalogs: TranslationCatalogs;
  hash: string;
  locale: SupportedLocale;
  namespace: string;
}

function getTranslation(options: GetTranslationOptions): string | undefined {
  return options.catalogs[options.locale]?.[options.namespace]?.[options.hash];
}
